// 画面右上にトーストを出す。
//
// NOTE: サーバー側の flash ( layouts/application ) と同じ見た目・同じ Stimulus コントローラを使う。
//       data-controller="toast" を付けて body に挿すと Stimulus が拾って自動で消える。
const VARIANTS = {
  notice: {
    duration: 4000,
    box: "border-emerald-200 bg-emerald-50",
    icon: "text-emerald-500",
    text: "text-emerald-800",
    path: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
  },
  alert: {
    duration: 6000,
    box: "border-red-200 bg-red-50",
    icon: "text-red-500",
    text: "text-red-800",
    path: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z"
  }
}

export function showToast(message, variant = "alert") {
  const style = VARIANTS[variant] || VARIANTS.alert

  const wrapper = document.createElement("div")
  wrapper.className = "fixed top-4 right-4 z-50 max-w-sm"
  wrapper.dataset.controller = "toast"
  wrapper.dataset.toastDurationValue = String(style.duration)

  const box = document.createElement("div")
  box.className = `flex items-center gap-3 rounded-lg border ${style.box} px-4 py-3 shadow-lg transition-opacity duration-300`

  const icon = document.createElementNS("http://www.w3.org/2000/svg", "svg")
  icon.setAttribute("class", `h-5 w-5 shrink-0 ${style.icon}`)
  icon.setAttribute("viewBox", "0 0 20 20")
  icon.setAttribute("fill", "currentColor")
  icon.setAttribute("aria-hidden", "true")
  const path = document.createElementNS("http://www.w3.org/2000/svg", "path")
  path.setAttribute("fill-rule", "evenodd")
  path.setAttribute("clip-rule", "evenodd")
  path.setAttribute("d", style.path)
  icon.appendChild(path)

  // NOTE: textContent で入れるので サーバーからのメッセージをそのまま渡してよい
  const text = document.createElement("p")
  text.className = `text-sm font-medium ${style.text}`
  text.textContent = message

  box.append(icon, text)
  wrapper.appendChild(box)
  document.body.appendChild(wrapper)

  return wrapper
}
